import Aside from './src/components/edAside';
import AsideMenu from './src/components/edAsideMenu';
import AdaptButton from './src/components/adaptButton';
import Breadcrumb from './src/components/breadcrumb';
import CardTable from './src/components/cardTable';
import Checkbox from './src/components/checkbox';
import DefaultButton from './src/components/defaultButton';
import DropdownMenu from './src/components/dropdownMenu';
import RectangleButton from './src/components/rectangleButton';
import SearchBar from './src/components/searchBar';
import SquaredButton from './src/components/squaredButton';
import SwitchView from './src/components/switchView';
import Table from './src/components/edTable';
import Tooltip from './src/components/tooltip';

const options = {
  Aside,
  AsideMenu,
  AdaptButton,
  Breadcrumb,
  CardTable,
  Checkbox,
  DefaultButton,
  DropdownMenu,
  RectangleButton,
  SearchBar,
  SquaredButton,
  SwitchView,
  Table,
  Tooltip,
};

options.install = function(Vue) {
  for (let component in options) {
    const componentInstaller = options[component];
    if (componentInstaller && component !== 'install') {
      Vue.use(componentInstaller);
    }
  }
};

export default options;


//////////////////
// WEBPACK FOOTER
// ./~/edoc-library/index.js
// module id = 643
// module chunks = 41